import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import Page from "@/components/Page";
import Loading from "@/components/Loading";
import Breadcrumbs from "@/components/Breadcrumbs";
import MainActions from "@/components/MainActions";
import CardsList from "@/components/CardsList";

import EmptyData from "@/components/EmptyData";

import {RosterAPI} from "@/api/roster";
import {visibleRosters} from "@/utils/functions";

import AddIcon from "@mui/icons-material/Add";

import {ERROR_OPERATION, getInternalClubId} from "@/utils/constants";

import "./index.scss";

function ManagerFootballTeamsPage(props) {
	const {handleNotification} = props;

	const navigate = useNavigate();
	const seasonId = useSelector((state) => state?.season?.id);

	const [loading, setLoading] = useState(false);
	const [teams, setTeams] = useState([]);

	const getTeams = async () => {
		setLoading(true);
		try {
			const response = await RosterAPI.list({
				seasonId,
				prospect: false,
				clubId: getInternalClubId(),
			});
			setTeams(
				visibleRosters(
					(response || []).filter(
						(t) =>
							!t.prospect && (!t.clubId || t.clubId === getInternalClubId()),
					),
				),
			);
		} catch (error) {
			handleNotification(ERROR_OPERATION, "error");
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getTeams();
	}, [seasonId]);

	const listConfiguration = {
		data: teams,
		onClick: (team) => navigate("/manager/teams/" + team.id),
	};

	const headerActions = [
		{
			icon: <AddIcon />,
			title: "Nuova rosa",
			onClick: () => navigate("/manager/teams/new"),
		},
	];

	return (
		<Page>
			<Loading visible={loading} />
			<Breadcrumbs
				current="Rose"
				actions={<MainActions actions={headerActions} />}
			/>
			{!loading && teams.length === 0 ? (
				<EmptyData
					action={
						<MainActions
							actions={[
								{
									icon: <AddIcon />,
									label: "Crea la prima rosa",
									onClick: () => navigate("/manager/teams/new"),
								},
							]}
						/>
					}
				>
					Nessuna rosa per la stagione selezionata.
				</EmptyData>
			) : (
				<CardsList
					type="manager_football_team"
					breadcrumbs
					listConfiguration={listConfiguration}
				/>
			)}
		</Page>
	);
}

export default ManagerFootballTeamsPage;
